// Workflow onay kuyruğu API (Faz 2). GET /admin/workflow/queue — cross-content-type
// bekleyen onaylar (body YOK). read-only.

import { http, unwrapList, type ActionResponse, type PaginationInfo } from './http';

/** BE ContentTypes discriminator (PascalCase). */
export type WorkflowContentType = 'Article' | 'Page' | 'Sss' | 'Campaign';

export interface WorkflowQueueItem {
  contentType: string;
  contentId: string;
  title: string;
  status: number;
  languageId: string;
  submittedById: string | null;
  updatedAt: string;
}

interface WorkflowQueueItemDto {
  contentType: string | null;
  contentId: string;
  title: string | null;
  status: number;
  languageId: string;
  submittedById: string | null;
  updatedAt: string;
}

export interface WorkflowQueueQuery {
  state?: number;
  contentType?: string;
  page?: number;
  pageSize?: number;
}

function mapItem(d: WorkflowQueueItemDto): WorkflowQueueItem {
  return {
    contentType: d.contentType ?? '',
    contentId: d.contentId,
    title: d.title ?? '',
    status: d.status,
    languageId: d.languageId,
    submittedById: d.submittedById,
    updatedAt: d.updatedAt,
  };
}

export const workflowQueueApi = {
  async list(query: WorkflowQueueQuery = {}): Promise<{ items: WorkflowQueueItem[]; pagination: PaginationInfo | null }> {
    const p = new URLSearchParams();
    if (query.state !== undefined) p.set('state', String(query.state));
    if (query.contentType) p.set('contentType', query.contentType);
    if (query.page) p.set('page', String(query.page));
    if (query.pageSize) p.set('pageSize', String(query.pageSize));
    const qs = p.toString();
    const res = await http.get<ActionResponse<WorkflowQueueItemDto>>(
      `/api/v1/admin/workflow/queue${qs ? `?${qs}` : ''}`,
    );
    const { items, pagination } = unwrapList(res);
    return { items: items.map(mapItem), pagination };
  },
};
